import { SidebarMenuItem } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-item.model';

export class SidebarMenuContainer {
  constructor(initData?: Partial<SidebarMenuContainer>) {
    if (initData) {
      Object.assign(this, initData);
    }
  }

  public expanded = false;
  public name = '';
  public icon = '';
  public style: { transform: string };

  public sublings = new Array<SidebarMenuItem | SidebarMenuContainer>();
  public hidden: () => boolean = () => false;
}
